import MapKeywordItem from "../../publicmap/MapKeywordItem";
import styles from "./SideSheetTop.module.css";

interface SideSheetTopProps {
    title: string;
    keywords: string[] | undefined;
}

/**
 * @author mjkang
 * @date 2024-09-03 10:52:48
 * @remark 지도 제목 & 키워드 영역
 * @returns SideSheetTop
 */
const SideSheetTop = (props: SideSheetTopProps) => {
    return (
        <div className={styles.wrapper}>
            <div className={`${styles.title} ${props.title.length >= 15 && styles.overflow}`}>{props.title}</div>
            <div className={styles.keyword}>
                {props.keywords &&
                    props.keywords.map((item, idx) => {
                        return (
                            <div className={styles.item} key={idx}>
                                <MapKeywordItem title={item} />
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default SideSheetTop;
